import { css } from 'emotion';
import { helvetica, grey } from 'inside-out/global-styles';

export const wrapperStyle = css({
	...helvetica,
	'& a': {
		fontSize: '14px',
		textDecoration: 'none',
		display: 'block',
		lineHeight: '29px',
		color: grey,
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/linkList/styles.js